import React from "react";
import Options from "../../Components/pages/options/options";

function Index() {
  return <Options />;
}

export default Index;
